import { apiCall } from '../../../../_services/apiCall';
import config from '../../../../config/config';


export const listAlertRules = async () => {
  const response = await apiCall(
    `${config.POSTLOGIN_API_URL_COMPANY}iot-meters/alert-rules`,
    {},
    {},
    'GET'
  );
  return response?.data || [];
};

export const getAlertRule = async (alertRuleId) => {
  const response = await apiCall(
    `${config.POSTLOGIN_API_URL_COMPANY}alert-rules/${alertRuleId}`,
    {},
    {},
    'GET'
  );
  return response?.data?.data;
};

export const createAlertRule = async (data) => {
  const response = await apiCall(
    `${config.POSTLOGIN_API_URL_COMPANY}iot-meters/alert-rules`,
    {},
    data,
    'POST'
  );
  return response?.data?.data;
};

export const updateAlertRule = async (alertRuleId, data) => {
  const response = await apiCall(
    `${config.POSTLOGIN_API_URL_COMPANY}alert-rules/${alertRuleId}`,
    {},
    data,
    'PUT'
  );
  return response?.data?.data;
};

export const deleteAlertRule = async (alertRuleId) => {
  const response = await apiCall(
    `${config.POSTLOGIN_API_URL_COMPANY}alert-rules/${alertRuleId}`,
    {},
    {},
    'DELETE'
  );
  return response?.data;
};
